<template>
	<div class="one_01">
		<router-tab append="last" :keep-last-tab="false" restore="false" icon="el-icon-menu" />
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	components: {
	},

	mounted() {
	},

	methods: {
		// 回到控制台
		clickHome() {
			this.$router.push({
				path: '/exeIndex/mainIndex/workbench'
			})
		},
		// 后退
		clickBack() {
			this.$router.go(-1)
		},

		// 前进
		clickNext() {
			this.$router.go(1)
		},

		// 刷新
		clickRefresh() {
			this.$router.go(0)
		}

	}
}
</script>


<style scoped>
.home-container {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: #FFFFFF;
}

.one_01 {
	width: 100%;
	height: 100%;
	background: #e7e7e7;
	position: relative;
	display: flex;
	flex-direction: column;
	min-height: 0;
}

::v-deep .router-tab {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: 0 !important;
}

::v-deep .router-tab__header {
  flex-shrink: 0;
  height: auto !important;
  min-height: 40px;
}

::v-deep .router-tab__scroll {
  height: auto !important;
  min-height: 40px;
}

::v-deep .router-tab__container {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

::v-deep .router-tab__content {
  flex: 1;
  overflow: auto;
}
</style>